import React from "react";
import "./legal.css";
import { SiteHeader as Header, SiteFooter as Footer } from "./chrome.jsx";

const privacySections = [
  {
    title: "Information We Collect",
    body: "We may collect information such as your name, email address, phone number, company details, messages, project requirements and other information submitted through our website.",
  },
  {
    title: "How We Use Information",
    body: "Information may be used to respond to enquiries, provide services, communicate with clients, process requests, provide support and improve our website.",
  },
  {
    title: "Cookies & Analytics",
    body: "Our website may use cookies and analytics tools to understand website usage, improve performance and provide a better user experience.",
  },
  {
    title: "Information Sharing",
    body: "Information may be shared with trusted service providers such as hosting, email, payment, analytics and technology providers when necessary to provide our services.",
  },
  {
    title: "Data Security",
    body: "We use reasonable technical and organisational measures to protect personal information against unauthorised access, misuse or disclosure.",
  },
  {
    title: "Data Retention",
    body: "Information may be retained for as long as reasonably necessary for business, service, legal or security purposes.",
  },
  {
    title: "Third-Party Websites",
    body: "Our website may contain links to third-party websites. Hallef Technologies is not responsible for their privacy practices or content.",
  },
  {
    title: "Careers & Resumes",
    body: "Information submitted through career applications, including resumes, contact details, education and work experience, may be used for recruitment purposes.",
  },
  {
    title: "Privacy Requests",
    body: "Users may contact Hallef Technologies regarding applicable requests relating to their personal information.",
  },
  {
    title: "Policy Updates",
    body: "This Privacy Policy may be updated from time to time. The latest version will be published on this page.",
  },
];

const termsSections = [
  {
    title: "Project Scope",
    body: "All services will be provided according to the approved quotation, proposal and project requirements. Any work outside the agreed scope may require additional charges.",
  },
  {
    title: "Project Changes",
    body: "Changes to approved designs, features, functionality or requirements may affect the project cost and delivery timeline.",
  },
  {
    title: "Client Responsibilities",
    body: "The client must provide accurate content, images, documents, approvals and other required information on time. Delays in providing these materials may affect delivery.",
  },
  {
    title: "Project Timeline",
    body: "Hallef Technologies will make reasonable efforts to complete projects within the agreed timeline. Delays caused by client approvals, requirement changes, third-party services or technical issues may change the delivery date.",
  },
  {
    title: "Payments",
    body: "Payments must be made according to the approved quotation or milestone schedule. Outstanding payments may delay project delivery, launch or transfer.",
  },
  {
    title: "Cancellation & Refunds",
    body: "Cancellation requests must be submitted in writing. Refund eligibility depends on the project stage, completed work, resources used and the agreed commercial terms. Third-party payments may be non-refundable.",
  },
  {
    title: "Hosting & Domain",
    body: "Domain, hosting, SSL certificates and other third-party services are included only when specifically mentioned in the quotation. Otherwise, they are charged separately.",
  },
  {
    title: "Third-Party Services",
    body: "Projects may use payment gateways, APIs, hosting providers, plugins, software or other third-party services. Their availability, pricing and policies are controlled by the respective providers.",
  },
  {
    title: "Intellectual Property",
    body: "Client-specific content belongs to the client or its respective owner. Ownership or source-code transfer will follow the terms agreed in the project quotation and may require all outstanding payments to be cleared.",
  },
  {
    title: "Maintenance",
    body: "Maintenance may include agreed technical support, updates and minor changes. Major modifications, redesigns or new features may be charged separately.",
  },
  {
    title: "Liability",
    body: "Hallef Technologies will take reasonable steps to provide reliable services but is not responsible for issues caused by third-party providers, hosting failures, client actions, external attacks or circumstances beyond reasonable control.",
  },
  {
    title: "Updates to Terms",
    body: "Hallef Technologies may update these Terms & Conditions when required. Updated terms will be published on this page.",
  },
];

function LegalPage({ kicker, title, intro, sections }) {
  return (
    <>
      <Header />
      <main className="legal-page">
        <section className="legal-hero">
          <p className="kicker">{kicker}</p>
          <h1>{title}</h1>
          <span>Last updated: October 5, 2026</span>
          <p>{intro}</p>
        </section>

        <section className="legal-content">
          {sections.map((section) => (
            <article key={section.title}>
              <h2>{section.title}</h2>
              <p>{section.body}</p>
            </article>
          ))}

          <article>
            <h2>Contact</h2>
            <p>
              For questions, contact Hallef Technologies at{" "}
              <a href="mailto:info@halleftechnologies.com">
                info@halleftechnologies.com
              </a>

              No 18, Buddha Vihara Road Cox Town, Bangalore, Karnataka,
              India - 560005.
            </p>
          </article>
        </section>
      </main>
      <Footer />
    </>
  );
}

export function PrivacyPolicy() {
  return (
    <LegalPage
      // kicker="Privacy"
      title="Privacy Policy"
      intro="This Privacy Policy explains how Hallef Technologies collects, uses and protects information submitted through our website."
      sections={privacySections}
    />
  );
}

export function TermsConditions() {
  return (
    <LegalPage
      // kicker="Terms"
      title="Terms & Conditions"
      intro="These Terms & Conditions explain the service terms, responsibilities and project policies for Hallef Technologies."
      sections={termsSections}
    />
  );
}
